import React from "react";

const NavbarSkip = () => {
  return (
    <div className="w-full flex justify-between items-center mx-auto py-4 px-2 lg:p-4  shadow-md border-2">
      <h1 className=" pl-2 lg:pl-10 basis-1/2 text-2xl font-bold">
       
        <span className="text-rose-600">Apna </span>
        <span className="text-sky-600">App </span>
  
      </h1>
      <div className="flex-grow lg:basis-1/2 pr-2 lg:pr-12">
        <ul className="style-none flex w-full justify-end ">
          <li className="mx-2 lg:mx-3 text-base   lg:text-base font-semibold hover:text-red-500">
            <a href="/">Sign up</a>
          </li>
          <li className=" mx-2 lg:mx-3 text-base  lg:text-base font-semibold hover:text-red-500">
            <a href="/">Sign in</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NavbarSkip;
